module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Black.1a7d463.eot";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Black/SFProDisplay-Black.eot
// module id = 06U2
// module chunks = 24